import React from "react";
import AccountancyHeader from "../components/Courses/Accountancy/AccountancyHeader";
import AccountancyCareerSkills from "../components/Courses/Accountancy/AccountancyCareerSkills";
import AccountancyProgramsCard from "../components/Courses/Accountancy/ExploreProgramsAccountancy";
import AccountancyAdmissionRequirements from "../components/Courses/Accountancy/AccountancyAdmissionRequirements";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const Accountancy = () => {
  return (
    <div>
      <Navbar />
      <AccountancyHeader />
      <AccountancyCareerSkills />
      <AccountancyProgramsCard />
      <AccountancyAdmissionRequirements />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default Accountancy;
